module.exports = __webpack_public_path__ + "static/media/Kumana.199fb813.png";